"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetFormData = void 0;
const react_1 = require("react");
const immer_1 = require("immer");
const store_1 = require("../store");
const Api_1 = __importDefault(require("../services/Api"));
const useSetCalcResponse_1 = require("./useSetCalcResponse");
const useSetGlobalError_1 = require("./useSetGlobalError");
const GlobalError_1 = require("../interfaces/GlobalError");
const useConfig_1 = require("./useConfig");
const useSetConfig_1 = require("./useSetConfig");
const TextHelper_1 = require("../services/TextHelper");
const getError = (error) => {
    const errObj = Object.assign(Object.assign({}, (0, GlobalError_1.toErrorWithMessage)(error)), { severity: 'info' });
    if (typeof error === 'string' && error.startsWith('Invalid Phone Number')) {
        return {
            message: '<strong>The phone number is invalid.</strong><p>Please edit the number to be in one of the following formats:</p><ul><li>Australian Mobile: 0433 123 456</li><li>International Mobile: +61 433 123 456</li><li>Landline with Areacode: 02 9449 1234</li><li>International Landline: +61 2 9449 1234</li></ul><p><em>*note: spaces or dashes are allowed but not required</em></p>',
            severity: 'error',
        };
    }
    return errObj;
};
const useSetFormData = () => {
    const setState = (0, store_1.useSetState)();
    const setCalcResponse = (0, useSetCalcResponse_1.useSetCalcResponse)();
    const setGlobalError = (0, useSetGlobalError_1.useSetGlobalError)();
    const config = (0, useConfig_1.useConfig)();
    const setConfig = (0, useSetConfig_1.useSetConfig)();
    const setFormData = (0, react_1.useCallback)((data_1, ...args_1) => __awaiter(void 0, [data_1, ...args_1], void 0, function* (data, suppressActions = false, silentLoad = false) {
        // Set Form Data
        // We're stringifying the data as there was an edge case when setting extras
        // Getting error "'get' on proxy: property 'balanceForward' is a read-only and non-configurable data property on the proxy target but the proxy did not return its actual value (expected '[object Array]' but got '[object Array]')"
        setState((obj) => (0, immer_1.produce)(obj, (draft) => {
            draft.formData = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(data))), { suppressActions });
        }));
        if (!silentLoad) {
            setCalcResponse(true, undefined);
            try {
                const res = yield Api_1.default.postEnquiry(Object.assign(Object.assign({}, data), { suppressActions }));
                const hydratedConfig = (0, TextHelper_1.hydrateConfigWithApiResponse)(config, res);
                setConfig(hydratedConfig);
                setCalcResponse(false, res);
            }
            catch (error) {
                setCalcResponse(false, undefined, true);
                setGlobalError(getError(error));
            }
        }
    }), [setState]);
    return setFormData;
};
exports.useSetFormData = useSetFormData;
